import { render, staticRenderFns } from "./create-educational-material.vue?vue&type=template&id=9947e26c&scoped=true&"
import script from "./create-educational-material.vue?vue&type=script&lang=js&"
export * from "./create-educational-material.vue?vue&type=script&lang=js&"
import style0 from "./create-educational-material.vue?vue&type=style&index=0&id=9947e26c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9947e26c",
  null
  
)

export default component.exports